import { getCookieConsent } from '../../utils/config/cookies';
import { isUserLoggedIn } from '../../utils/function';
import { getPushPermissionState } from './pushPermission';

/**
 * Single place to read permission, consent, and auth for push-related logic.
 * Does not persist or mutate storage.
 *
 * `permission` always comes from live `Notification.permission` (via getPushPermissionState),
 * not from cookies — external settings changes are visible on the next call.
 */
export const getUnifiedPushState = () => ({
  permission: getPushPermissionState(),
  consent: getCookieConsent(),
  isLoggedIn: isUserLoggedIn(),
});
